import { getEnumKey } from '@instinet-analytics/core-lib';

export enum CorpActionTypeHolidayEnum {
    H = 'Holiday',
}

export const CorpActionTypeHolidayValue = getEnumKey(
    CorpActionTypeHolidayEnum,
    CorpActionTypeHolidayEnum.H
) as string;

export type CorpActionTypeHolidayValue = keyof typeof CorpActionTypeHolidayEnum;

export function isCorpActionHolidayType(key: string): boolean {
    return key === CorpActionTypeHolidayValue;
}

export enum HolidayType {
    T = 'Trading',
    S = 'Settlement',
}

// We receive this value eg "T" in the API...
export type HolidayTypeValue = keyof typeof HolidayType;
